import ChatAction from "@/chatbot-library/ChatAction"

class ChatMessage extends ChatAction {
  get name() {
    return "message"
  }

  getResponseContent(value) {
    return value
  }
}

export default ChatMessage
